<template>
  <div :key="page_key" class="page__voucher a-page">
    <div style="background-color:white; padding: 15px; border-radius: 4px; overflow: hidden">
      <el-row>
        <el-col :sm="8">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                       :disabled="current_component !== 'list'"></shop-select>
        </el-col>
        <el-col v-if="current_component === 'list'" :sm="16" class="text-right">
          <div style="display: flex; align-items: center; gap: 5px; justify-content: flex-end">
            <el-select size="small" value="" v-model="metrics_period" @change="m__get_voucher_metrics()"
                       style="margin-right: 10px">
              <el-option value="real_time" :label="$t('day.realtime')"></el-option>
              <el-option value="yesterday" :label="$t('day.yesterday')"></el-option>
              <el-option value="past7days" :label="$t('day.past7days')"></el-option>
              <el-option value="past30days" :label="$t('day.past30days')"></el-option>
              <el-option value="month" :label="$t('center.by_month')"></el-option>
            </el-select>
            <template v-if="metrics_period === 'month'">
              <el-date-picker
                id="date-picker-data-center"
                v-model="selected_month"
                type="month"
                format="MM-yyyy"
                style="margin-right: 10px"
                :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
                :placeholder="$t('select.month')"
                size="small"
                :clearable="false"
                @change="m__get_voucher_metrics()"
              >
              </el-date-picker>
            </template>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="m__show_create_component(null)">
              {{ $t('voucher.create') }}
            </el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="m__show_create_multiple_component">
              {{ $t('voucher.create_multiple') }}
            </el-button>
          </div>
        </el-col>
      </el-row>

      <div v-if="current_component === 'list'">
        <div style="margin-top: 30px">
          <div style="display: flex; gap: 15px; padding-bottom: 10px;" class="hide-scroll">
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.sales') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ m__calculate(voucher_metrics.sales) | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ 'AOV' }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ m__calculate(voucher_metrics.aov) | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ 'Nhận' }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ voucher_metrics.claims | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.orders') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ voucher_metrics.orders | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ 'Tỉ lệ sử dụng' }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ voucher_metrics.usage_rate ? (voucher_metrics.usage_rate * 100).toFixed(2) : 0 }}%
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ 'Người mua' }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ voucher_metrics.buyers | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ 'Chi phí' }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ m__calculate(voucher_metrics.cost) | currency }}
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex; margin-top: 50px">
          <div style="flex: 1; padding-right: 5px;">
            <el-tabs v-model="promotion_type" @tab-click="() => {voucher_filter.current_page = 0; m__get_voucher()}">
              <el-tab-pane :label="$t('base.all')" name="0"></el-tab-pane>
              <el-tab-pane :label="$t('base.ongoing')" name="2"></el-tab-pane>
              <el-tab-pane :label="$t('base.upcoming')" name="1"></el-tab-pane>
              <el-tab-pane :label="$t('base.expired')" name="3"></el-tab-pane>
              <el-tab-pane :label="`${$t('voucher.saved_files')} (${voucher_file_list.length})`"
                           name="file"></el-tab-pane>
            </el-tabs>
          </div>
          <div style="width: 350px; height: 30px; display: flex; padding-top: 5px" class="merge-select-input">
            <el-select size="mini" v-model="search_voucher_type" style="width: 150px">
              <el-option :label="'Tìm kiếm theo tên'" value="name"></el-option>
              <el-option :label="'Tìm kiếm theo mã'" value="code"></el-option>
            </el-select>
            <el-input v-model="search_keywords" size="mini" :placeholder="$t('input.placeholder')"
                      style="width: 200px" suffix-icon="el-icon-search" class="input" clearable
                      @keydown.enter.native="m__get_voucher()" @clear="m__get_voucher()">
            </el-input>
          </div>
        </div>
        <br>

        <div v-if="promotion_type === 'file'">
          <el-table :data="voucher_file_list">
            <el-table-column :label="$t('base.filename')" prop="name">
              <template slot-scope="scope">
                {{ scope.row.name }} <br>
                <div style="font-size: 11px; font-weight: 600">ID: {{ scope.row._id }}</div>
                <div style="display: flex">
                  <div v-if="scope.row.config_auto" class="text-running" @click="m__show_config_auto_dialog(scope.row)">
                    <a href="javascript:void(0)">{{ $t('flash_sale.auto_config_message_2') }}</a>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('voucher.name')">
              <template slot-scope="scope">
                <span>{{ scope.row.data ? scope.row.data.name : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('voucher.type')" prop="type"></el-table-column>
            <el-table-column :label="$t('base.discount')">
              <template slot-scope="scope">
                <template v-if="scope.row.data">
                  {{
                    +scope.row.data.value ? format_currency(+scope.row.data.value) + m__currency() : +scope.row.data.discount + '% ' + $t('flash_sale.discount')
                  }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="150px">
              <template slot-scope="scope">
                <template>
                  <el-button type="text" size="mini" @click="m__show_config_auto_dialog(scope.row)">
                    <strong class="text-primary">{{ $t('voucher.auto_config') }}</strong>
                  </el-button>
                  <br>
                  <el-button type="text" size="mini" @click="m__copy_voucher_from_file(scope.row, 'update_file')">
                    <strong class="text-primary">{{ $t('base.edit_file') }}</strong>
                  </el-button>
                  <br>
                </template>
                <el-button type="text" size="mini" @click="m__copy_voucher_from_file(scope.row, 'create')">
                  <strong class="text-primary">Tạo voucher từ file</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini" @click="m__delete_voucher_file(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table :data="voucher_list" v-loading="loading.get_voucher">
            <el-table-column :label="`${$t('voucher.name')} | ${$t('base.code')}`" width="300px">
              <template slot-scope="scope">
                <div style="padding: 10px">
                  <strong style="font-size: 13px">{{ scope.row.voucher_code }}</strong><br>
                  <span style="font-size: 12px; color: #666">{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('voucher.type')" width="200px">
              <template slot-scope="scope">
                <!--                <pre>{{ scope.row }}</pre>-->
                <span>{{ scope.row.type }}</span>
                <br>
                <template v-if="scope.row.rule && scope.row.rule.items && scope.row.rule.items.length">
                  <span style="font-size: 11px; color: #666">
                    ({{ scope.row.rule.items.length }} {{ $t('base.products') }})
                  </span>
                </template>
                <template v-else>
                  <span style="font-size: 11px; color: #666">({{ $t('product.all') }})</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.discount')" width="120px">
              <template slot-scope="scope">
                <template v-if="scope.row.rule.coin_cashback_voucher">
                  {{ +scope.row.rule.coin_cashback_voucher.coin_percentage_real + '% ' + $t('voucher.coin_cashback') }}
                </template>
                <template v-else>
                  {{
                    +scope.row.value ? format_currency(+scope.row.value) + m__currency() : +scope.row.discount + '% ' + $t('flash_sale.discount')
                  }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('voucher.no_of')" width="130px">
              <template slot-scope="scope">{{ scope.row.usage_limit | currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('voucher.saved_quantity')">
              <template slot-scope="scope">{{ scope.row.distributed_count | currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('voucher.usage_quantity')">
              <template slot-scope="scope">{{ scope.row.current_usage | currency }}</template>
            </el-table-column>
            <el-table-column :label="$t('base.created_at')" width="150px">
              <template slot-scope="scope">{{ scope.row.ctime * 1000 | moment('HH:mm DD/MM/YYYY') }}</template>
            </el-table-column>
            <el-table-column :label="`${$t('base.status')} | ${$t('voucher.claiming_period')}`" min-width="150px">
              <template slot-scope="scope">
                <div v-if="scope.row.fe_status === 2"
                     class="shopee-tag shopee-tag__information shopee-tag--normal success">{{ $t('base.ongoing') }}
                </div>
                <div v-if="scope.row.fe_status === 1"
                     class="shopee-tag shopee-tag__information shopee-tag--normal default">{{ $t('base.upcoming') }}
                </div>
                <div v-if="scope.row.fe_status === 3"
                     class="shopee-tag shopee-tag__information shopee-tag--normal invalid">{{ $t('base.expired') }}
                </div>
                <br>
                {{ scope.row.start_time * 1000 | moment('HH:mm DD/MM/YYYY') }} - <br>
                {{ scope.row.end_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="120px" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__show_create_component(scope.row.voucher_id)">
                  <strong class="text-primary">{{ $t('base.copy') }}</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini"
                           @click="m__show_create_voucher_file_dialog(scope.row.voucher_id, scope.row.type)">
                  <strong class="text-primary">{{ $t('base.save_file') }}</strong>
                </el-button>
                <template v-if="scope.row.fe_status === 2">
                  <br>
                  <el-button type="text" size="mini" @click="m__show_create_component(scope.row.voucher_id, true)">
                    <strong class="text-primary">{{ $t('base.edit') }}</strong>
                  </el-button>
                  <br>
                  <el-button type="text" size="mini" @click="m__stop_voucher(scope.row)">
                    <strong class="text-warning">{{ $t('base.end') }}</strong>
                  </el-button>
                </template>
                <template v-if="scope.row.fe_status === 1">
                  <br>
                  <el-button type="text" size="mini" @click="m__delete_voucher(scope.row)">
                    <strong class="text-danger">{{ $t('base.delete') }}</strong>
                  </el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page.sync="voucher_filter.current_page" :page-size="voucher_filter.page_size"
                         layout="prev, pager, next, total" :total="voucher_filter.total_count"
                         @current-change="m__get_voucher()"/>
        </div>
      </div>

      <div v-if="current_component === 'create'">
        <br>
        <el-row style="margin: 25px 0;">
          <el-col :sm="2" style="padding-top: 10px">
            <el-button size="mini" icon="el-icon-arrow-left"
                       @click="current_component = 'list'; has_new_voucher && m__get_voucher(); has_new_voucher = false">
              {{ $t('base.back') }}
            </el-button>
          </el-col>
          <el-col :sm="8" style="padding-top: 15px; padding-left: 15px">
            <p style="font-size: 14px; font-weight: bold">
              <template v-if="create_component_state === 'create'">
                {{ $t('voucher.create_title') }}
              </template>
              <template v-else-if="create_component_state === 'update_file'">
                {{ $t('base.edit_x', {x: 'file'}) }}
                <template v-if="copy_from_file">
                  "{{ copy_from_file.name }}"
                </template>
              </template>
            </p>
          </el-col>
          <el-col :sm="13" style="padding-top: 10px" class="text-right">
          </el-col>
        </el-row>

        <Page_CreateVoucherComponent :shop="shop"
                                     :seller="seller"
                                     :product_list="product_list"
                                     :selected_product_ids="selected_product_ids"
                                     :loading_product="loading.get_product"
                                     :copy_from_id="copy_from_id"
                                     :copy_from_file="copy_from_file"
                                     :has_new_voucher.sync="has_new_voucher"
                                     :voucher_list="voucher_list"
                                     :update_file_id="null"
                                     :is_update="is_update"
                                     :component_state="create_component_state"
                                     @m__get_product="m__get_product"
                                     @m__get_voucher_file="m__get_voucher_file"></Page_CreateVoucherComponent>
      </div>

      <div v-if="current_component === 'create_multiple'">
        <br>
        <el-row style="margin: 25px 0;">
          <el-col :sm="2" style="padding-top: 10px">
            <el-button size="mini" icon="el-icon-arrow-left"
                       @click="current_component = 'list'; has_new_voucher && m__get_voucher(); has_new_voucher = false">
              {{ $t('base.back') }}
            </el-button>
          </el-col>
          <el-col :sm="8" style="padding-top: 15px; padding-left: 15px">
            <p style="font-size: 14px; font-weight: bold">{{ $t('voucher.create_multiple_title') }}</p>
          </el-col>
          <el-col :sm="13" style="padding-top: 10px" class="text-right">
          </el-col>
        </el-row>

        <Page_CreateMultipleVoucherComponent :shop="shop"
                                             :seller="seller"
                                             :product_list="product_list"
                                             :selected_product_ids="selected_product_ids"
                                             :loading_product="loading.get_product"
                                             :voucher_list="voucher_list"
                                             @m__get_product="m__get_product">
        </Page_CreateMultipleVoucherComponent>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.create_voucher_file" :close-on-click-modal="false" custom-class="no-body"
               width="400px">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('voucher.filename') }}</p>
        <el-input size="mini" :placeholder="$t('input.filename')" v-model="voucher_file_name"></el-input>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.create_voucher_file"
                     @click="m__create_voucher_file()">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.voucher_file_list" :close-on-click-modal="false" custom-class="no-body"
               width="800px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('voucher.saved_files') }}</strong>

        <div style="margin-top: 30px">
          <el-table :data="voucher_file_list">
            <el-table-column :label="$t('base.filename')" prop="name">
              <template slot-scope="scope">
                {{ scope.row.name }} <br>
                <span style="font-size: 11px; font-weight: 600">ID: {{ scope.row._id }}</span> <br>
                <span v-if="scope.row.config_auto" class="text-running">
                  <a href="javascript:void(0)">{{ $t('flash_sale.auto_config_message_2') }}</a>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('voucher.type')" prop="type"></el-table-column>
            <el-table-column :label="$t('base.action')" width="150px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__show_config_auto_dialog(scope.row)">
                  <strong class="text-primary">{{ $t('voucher.auto_config') }}</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini" @click="m__copy_voucher_from_file(scope.row)">
                  <strong class="text-primary">{{ $t('base.update_file') }}</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini" @click="m__copy_voucher_from_file(scope.row)">
                  <strong class="text-primary">{{ $t('base.use_file') }}</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini" @click="m__delete_voucher_file(scope.row)">
                  <strong class="text-danger">{{ $t('base.delete') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_auto" :close-on-click-modal="false" custom-class="no-body"
               width="900px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('voucher.auto_config') }}</strong>

        <div style="padding: 0 10px">
          <div style="margin-top: 50px">
            <el-radio v-model="config_auto.type" label="daily">
              <strong style="font-size: 13px">{{ $t('voucher.auto_create_by_time_slots_daily') }}</strong>
            </el-radio>
            <div v-if="config_auto.type === 'daily'" style="padding-left: 25px; padding-top: 2px">
              <span style="color: #666">- Hệ thống sẽ tự động tạo voucher theo các khung giờ chỉnh định.</span>
              <br>
              <span style="color: #666">- Nếu như giờ tạo mã giảm giá lơn hơn giờ tạo voucher thì giờ tạo voucher sẽ
                được đẩy sang ngày hôm sau.</span>
            </div>

            <div v-if="config_auto.type === 'daily'"
                 style="margin-top: 30px; padding-left: 20px; display: flex; flex-direction: column; gap: 20px">
              <div v-if="false" style="display: flex; gap: 10px; align-items: center">
                <div style="width: 200px">
                  <strong class="strong-label">{{ 'Mã voucher' }}</strong>
                  <el-input size="mini" style="width: 200px"></el-input>
                </div>

                <div style="margin: 0 20px">
                  <strong class="strong-label">&nbsp;</strong>
                  <strong>&nbsp;</strong>
                </div>

                <div style="width: 200px">
                  <strong class="strong-label">{{ 'Mã voucher dự phòng' }}</strong>
                  <el-input size="mini" style="width: 200px"></el-input>
                </div>
              </div>

              <div style="display: flex; gap: 10px; align-items: center;">
                <div style="width: 200px">
                  <strong class="strong-label">{{ $t('base.from_date') }}</strong>
                  <el-input
                    v-model="config_auto_date.daily_start_day"
                    size="mini" type="number" :placeholder="$t('base.from_date')" style="width: 200px"></el-input>
                </div>

                <div style="margin: 0 20px">
                  <strong class="strong-label">&nbsp;</strong>
                  -
                </div>

                <div style="width: 200px">
                  <strong class="strong-label">{{ $t('base.to_date') }}</strong>
                  <el-input
                    v-model="config_auto_date.daily_end_day"
                    size="mini" type="number" :placeholder="$t('base.to_date')" style="width: 200px"></el-input>
                </div>
              </div>

              <div style="display: flex; gap: 10px; align-items: center;">
                <div style="width: 200px">
                  <strong class="strong-label">{{ $t('base.start_hour') }}</strong>
                  <el-time-select
                    v-model="config_auto_date.daily_start_hour"
                    style="width: 100%"
                    size="mini"
                    :placeholder="$t('base.start_hour')"
                    :clearable="false"
                    :picker-options="time_picker_options">
                  </el-time-select>
                </div>

                <div style="margin: 0 20px">
                  <strong class="strong-label">&nbsp;</strong>
                  -
                </div>

                <div style="width: 200px">
                  <strong class="strong-label">{{ $t('base.end_hour') }}</strong>
                  <el-time-select
                    v-model="config_auto_date.daily_end_hour"
                    style="width: 100%"
                    size="mini"
                    :placeholder="$t('base.end_hour')"
                    :clearable="false"
                    :picker-options="{...time_picker_options, minTime: config_auto_date.daily_start_hour}">
                  </el-time-select>
                </div>
              </div>

              <div style="display: flex; gap: 10px; align-items: center;">
                <div style="flex: 1">
                  <el-checkbox v-model="config_auto_date.allow_repeat">{{ $t('voucher.allow_repeat_monthly') }}
                  </el-checkbox>
                </div>
                <div style="flex: 2"></div>
              </div>

              <div style="display: flex; gap: 10px; align-items: center;">
                <div style="width: 200px">
                  <strong class="strong-label">{{ $t('voucher.create_hour') }}</strong>
                  <el-time-select
                    v-model="config_auto_date.daily_start_create_hour"
                    style="width: 100%"
                    size="mini"
                    :placeholder="$t('voucher.create_hour')"
                    :clearable="false"
                    :picker-options="{...time_picker_options}">
                  </el-time-select>
                </div>

                <div style="margin: 0 20px">&nbsp;</div>

                <div style="width: 200px;">
                  <strong class="strong-label">{{ $t('voucher.quantity_of_each_time_slot') }}</strong>
                  <el-input size="mini" type="number" v-model="config_auto_date.limit_session"></el-input>
                </div>
              </div>

              <div style="display: flex; gap: 10px; align-items: center; margin-top: 10px">
                <div style="width: 200px">
                  &nbsp;
                </div>

                <div style="margin: 0 20px">&nbsp;</div>

                <div style="width: 200px; text-align: right">
                  <el-button type="primary" size="mini" icon="el-icon-plus" @click="m__add_to_daily_list">
                    {{ $t('base.add_config') }}
                  </el-button>
                </div>
              </div>

              <div style="margin-top: 20px">
                <strong class="strong-label">{{ $t('voucher.auto_time_slot_list') }}</strong>

                <div style="margin-top: 10px">
                  <el-table :data="config_auto.daily_list">
                    <el-table-column :label="$t('voucher.create_time_slots')">
                      <template slot-scope="scope">
                        {{ $t('base.from_date') }}
                        {{ scope.row.start_day }}
                        {{ $t('base.to_date').toLowerCase() }}
                        {{ scope.row.end_day }}
                        <template v-if="scope.row.allow_repeat">{{ $t('base.monthly').toLowerCase() }}</template>

                        <br>
                        {{ scope.row.start_hour }} - {{ scope.row.end_hour }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('voucher.create_hour')">
                      <template slot-scope="scope">
                        {{ $t('voucher.create_at') }}
                        {{ scope.row.start_create_hour }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('voucher.quantity_of_each_time_slot')">
                      <template slot-scope="scope">
                        {{ scope.row.limit_session }} {{ $t('voucher.vouchers') }}
                      </template>
                    </el-table-column>
                    <el-table-column width="50px">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="m__remove_from_daily_list(scope.$index)">
                          <strong class="text-danger">{{ $t('base.delete') }}</strong>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="false" style="margin-top: 50px">
            <el-radio v-model="config_auto.type" label="monthly">
              <strong style="font-size: 13px">{{ $t('voucher.auto_create_monthly') }}</strong>
            </el-radio>
            <div v-if="config_auto.type === 'monthly'" style="padding-left: 25px; padding-top: 2px">
              <span style="color: #999">Hệ thống sẽ tự động tạo các voucher chạy trong tháng theo khoảng thời gian chỉ
                định.</span>
            </div>

            <div v-if="config_auto.type === 'monthly'" style="margin-top: 30px; padding-left: 20px">
              <div style="display: flex; gap: 10px; align-items: center">
                <div>
                  <strong>Thời gian bắt đầu</strong>

                  <div style="height: 5px"></div>

                  <el-input
                    v-model="config_auto_date.monthly_start_day"
                    size="mini" type="number" :placeholder="$t('base.from_date')" style="width: 110px"></el-input>

                  <el-time-select
                    v-model="config_auto_date.monthly_start_hour"
                    style="width: 110px;"
                    size="mini"
                    :placeholder="$t('select.hour')"
                    :clearable="false"
                    :picker-options="time_picker_options">
                  </el-time-select>
                </div>

                <div>
                  <strong>&nbsp;</strong>
                  <br>
                  <div style="margin: 0 5px">-</div>
                </div>

                <div>
                  <strong>
                    Thời gian kết thúc
                  </strong>

                  <div style="height: 5px"></div>

                  <el-input
                    v-model="config_auto_date.monthly_end_day"
                    size="mini" type="number" :placeholder="$t('base.to_date')" style="width: 110px"></el-input>

                  <el-time-select
                    v-model="config_auto_date.monthly_end_hour"
                    style="width: 110px;"
                    size="mini"
                    :placeholder="$t('select.hour')"
                    :clearable="false"
                    :picker-options="time_picker_options">
                  </el-time-select>
                </div>
              </div>
              <div style="margin-top: 20px; display: flex; align-items: center;">
                <div>
                  <div style="width: 200px">
                    <strong class="strong-label">{{ $t('voucher.create_hour') }}</strong>
                    <el-time-select
                      v-model="config_auto_date.daily_start_create_hour"
                      style="width: 100%"
                      size="mini"
                      :placeholder="$t('voucher.create_hour')"
                      :clearable="false"
                      :picker-options="{...time_picker_options}">
                    </el-time-select>
                  </div>
                </div>

                <div style="padding-left: 150px">
                  <strong class="strong-label">&nbsp;</strong>
                  <div style="height: 5px"></div>
                  <el-button type="primary" size="mini" icon="el-icon-plus"
                             @click="m__add_to_monthly_list">
                    Thêm cấu hình
                  </el-button>
                </div>
              </div>

              <div style="margin-top: 30px">
                <strong>{{ 'Danh sách các khung giờ chạy voucher trong tháng' }}</strong>

                <div style="margin-top: 10px">
                  <el-table :data="config_auto.monthly_list">
                    <el-table-column>
                      <template slot-scope="scope">
                        {{ $t('base.from_date') }}
                        {{ scope.row.start_day }} ({{ scope.row.start_hour }})
                        {{ $t('base.to_date') }}
                        {{ scope.row.end_day }} ({{ scope.row.end_hour }})
                      </template>
                    </el-table-column>
                    <el-table-column width="50px">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="m__remove_from_monthly_list(scope.$index)">
                          <strong class="text-danger">{{ $t('base.delete') }}</strong>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="false" style="margin-top: 50px">
            <el-radio v-model="config_auto.type" label="weekly">
              <strong style="font-size: 13px">{{ $t('voucher.auto_create_weekly') }}</strong>
            </el-radio>

            <div v-if="config_auto.type === 'weekly'" style="margin-top: 10px; padding-left: 20px; padding-right: 50px">
              <el-checkbox-group v-model="config_auto.weekly_list">
                <el-checkbox label="monday">{{ $t('day.monday') }}</el-checkbox>
                <el-checkbox label="tuesday">{{ $t('day.tuesday') }}</el-checkbox>
                <el-checkbox label="wednesday">{{ $t('day.wednesday') }}</el-checkbox>
                <el-checkbox label="thursday">{{ $t('day.thursday') }}</el-checkbox>
                <el-checkbox label="friday">{{ $t('day.friday') }}</el-checkbox>
                <el-checkbox label="saturday">{{ $t('day.saturday') }}</el-checkbox>
                <el-checkbox label="sunday">{{ $t('day.sunday') }}</el-checkbox>
              </el-checkbox-group>

              <div style="margin-top: 25px; display: flex; gap: 20px; align-items: center">
                <el-time-select
                  v-model="config_auto_date.weekly_start_hour"
                  style="width: 30%;"
                  size="mini"
                  :placeholder="$t('select.hour')"
                  :clearable="false"
                  :picker-options="time_picker_options">
                </el-time-select>

                <div>-</div>

                <el-time-select
                  v-model="config_auto_date.weekly_end_hour"
                  style="width: 30%;"
                  size="mini"
                  :placeholder="$t('select.hour')"
                  :clearable="false"
                  :picker-options="time_picker_options">
                </el-time-select>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 50px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-delete" @click="m__delete_config_auto()">
            {{ $t('base.delete_config') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.config_auto"
                     @click="m__update_config_auto()">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Page_CreateVoucherComponent from './create'
import Page_CreateMultipleVoucherComponent from './create_multi'
import {get_shop_mixins} from "../../mixins/get_shop";
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {check_channel, check_feature, show_expr_notification} from "../../addon/check_license";

export default {
  name: 'page__voucher',

  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {
    Page_CreateVoucherComponent,
    Page_CreateMultipleVoucherComponent
  },

  data() {
    return {
      page_key: '',

      seller: {},
      current_component: 'list',
      loading: {
        get_voucher: false,
        get_product: false,
        voucher_file_list: false,
        create_voucher_file: false,
        config_auto: false
      },
      show_dialog: {
        voucher_file_list: false,
        create_voucher_file: false,
        config_auto: false
      },
      voucher_filter: {
        page_size: 15,
        current_page: 0,
        keyword: '',
        total_count: 0
      },
      promotion_type: '0',
      voucher_list: [],
      product_list: [],
      selected_product_ids: [],
      copy_from_id: null,
      copy_from_file: null,

      selected_voucher_id: null,
      selected_voucher_type: null,

      voucher_file_name: '',
      voucher_file_list: [],
      selected_voucher_file: {},
      selected_voucher_file_id: null,

      config_auto_date: {
        voucher_code: null,
        second_voucher_code: null,
        daily_start_day: null,
        daily_start_create_hour: null,
        daily_start_hour: null,
        daily_end_day: null,
        daily_end_hour: null,
        limit_usage: null,
        session_number: null,
        limit_session: null,
        allow_repeat: true,

        monthly_start_create_hour: null,
        monthly_start_day: null,
        monthly_start_hour: null,
        monthly_end_day: null,
        monthly_end_hour: null,

        weekly_start_hour: null,
        weekly_end_hour: null,

        range_start_time: null,
        range_start_hour: null,
        range_end_time: null,
        range_end_hour: null
      },
      config_auto: {
        start_time: null,
        allow_repeat: false,
        repeat_after: null,

        type: 'daily',

        daily_list: [],

        monthly_list: [],

        weekly_list: [],
        weekly_start_hour: null,
        weekly_end_hour: null,

        range_start_time: null,
        range_start_hour: null,
        range_end_time: null,
        range_end_hour: null
      },

      has_new_voucher: false,

      is_update: false,

      time_picker_options: {
        start: '00:00',
        step: '00:15',
        end: '24:00'
      },

      create_component_state: 'create',

      search_voucher_type: 'name',
      search_keywords: '',

      voucher_metrics: {},
      metrics_period: 'past7days',
      selected_month: new Date(),
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('flash_sale') || check_channel('shopee_marketing_fs')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()
    await this.m__get_voucher_file()

    if (this.$route.query.product_ids && this.$route.query.product_ids.split(',').length) {
      this.selected_product_ids = this.$route.query.product_ids.split(',')
      this.create_component_state = 'create'
      this.current_component = 'create'
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.page_key = new Date().getTime()
      this.voucher_filter.current_page = 0
      this.m__initial_view()
    }
  },

  methods: {
    async m__get_voucher_metrics() {
      let start_time = null, end_time = null, period = this.metrics_period

      if (period === 'real_time') {
        start_time = this.dayjs().startOf('d').unix()
        end_time = this.dayjs().endOf('h').unix()
      } else if (period === 'yesterday') {
        start_time = this.dayjs().subtract(1, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (period === 'past7days') {
        start_time = this.dayjs().subtract(7, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (period === 'past30days') {
        start_time = this.dayjs().subtract(30, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (period === 'month') {
        start_time = this.dayjs(this.selected_month).startOf('month').unix()
        end_time = this.dayjs(this.selected_month).endOf('month').isAfter(this.dayjs())
          ? this.dayjs().startOf('d').unix()
          : this.dayjs(this.selected_month).endOf('month').add(1, 's').unix()
      }

      this.voucher_metrics = {}
      const voucher_metrics_response = await this.seller.marketing_get_voucher_metrics(start_time, end_time, period)
      console.log('voucher_metrics_response', voucher_metrics_response)
      if (voucher_metrics_response && voucher_metrics_response.data && voucher_metrics_response.data.result) {
        for (const key of Object.keys(voucher_metrics_response.data.result)) {
          this.voucher_metrics[key] = +voucher_metrics_response.data.result[key].value
        }

        this.voucher_metrics.aov = this.voucher_metrics.orders ? this.seller.m__calculate(this.voucher_metrics.sales / this.voucher_metrics.orders) : 0
      }
      this.voucher_metrics = this.clone(this.voucher_metrics)
    },

    m__remove_from_daily_list(index) {
      this.config_auto.daily_list.splice(index, 1)
    },

    m__remove_from_monthly_list(index) {
      this.config_auto.monthly_list.splice(index, 1)
    },

    m__add_to_daily_list() {
      if (!this.config_auto_date.daily_start_day) {
        this.ntf_w('Vui lòng ngày bắt đầu')
        return
      }

      if (!this.config_auto_date.daily_end_day) {
        this.ntf_w('Vui lòng ngày kết thúc')
        return
      }

      if (this.config_auto.daily_start_day > this.config_auto.daily_end_day) {
        this.ntf_w('Ngày bắt đầu phải nhỏ hơn ngày kết thúc')
        return
      }

      if (!this.config_auto_date.daily_start_hour) {
        this.ntf_w('Vui lòng chọn giờ bắt đầu')
        return
      }

      if (!this.config_auto_date.daily_end_hour) {
        this.ntf_w('Vui lòng chọn giờ kết thúc')
        return
      }

      if (!this.config_auto_date.daily_start_create_hour) {
        this.ntf_w('Vui lòng chọn giờ tạo voucher')
        return
      }

      if (!this.config_auto_date.limit_session) {
        this.ntf_w('Vui lòng nhập số lượng mã voucher')
        return
      }

      this.config_auto.daily_list.push({
        start_day: this.config_auto_date.daily_start_day,
        end_day: this.config_auto_date.daily_end_day,
        start_hour: this.config_auto_date.daily_start_hour,
        end_hour: this.config_auto_date.daily_end_hour,
        limit_usage: this.config_auto_date.limit_usage,
        session_number: this.config_auto_date.session_number,
        limit_session: this.config_auto_date.limit_session,
        allow_repeat: this.config_auto_date.allow_repeat,
        start_create_hour: this.config_auto_date.daily_start_create_hour
      })
    },

    m__add_to_monthly_list() {
      if (!this.config_auto_date.monthly_start_day || !this.config_auto_date.monthly_end_day ||
        !this.config_auto_date.monthly_start_hour || !this.config_auto_date.monthly_end_hour) {
        return
      }

      this.config_auto.monthly_list.push({
        start_day: this.config_auto_date.monthly_start_day,
        end_day: this.config_auto_date.monthly_end_day,
        start_hour: this.config_auto_date.monthly_start_hour,
        end_hour: this.config_auto_date.monthly_end_hour
      })
    },

    m__copy_voucher_from_file(file, state) {
      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }

      this.copy_from_id = null
      this.copy_from_file = file

      this.show_dialog.voucher_file_list = false
      this.create_component_state = state
      this.current_component = 'create'
    },

    async m__delete_config_auto() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_file/delete_config_auto', {file_id: this.selected_voucher_file_id}, this.cf())
      await this.m__get_voucher_file()
      this.show_dialog.config_auto = false
      this.ntf_s(this.$t('base.delete_success'))
    },

    async m__update_config_auto() {
      this.loading.config_auto = true

      this.config_auto.weekly_start_hour = this.config_auto_date.weekly_start_hour
      this.config_auto.weekly_end_hour = this.config_auto_date.weekly_end_hour
      this.config_auto.range_start_time = this.config_auto_date.range_start_time
      this.config_auto.range_start_hour = this.config_auto_date.range_start_hour
      this.config_auto.range_end_time = this.config_auto_date.range_end_time
      this.config_auto.range_end_hour = this.config_auto_date.range_end_hour

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_file/update_config_auto', {
        file_id: this.selected_voucher_file_id,
        config_auto: this.config_auto
      }, this.cf())
      await this.m__get_voucher_file()

      this.show_dialog.config_auto = false
      this.loading.config_auto = false
      this.ntf_s(this.$t('base.update_success'))
    },

    m__show_config_auto_dialog(data) {
      this.selected_voucher_file = this.clone(data)
      this.selected_voucher_file_id = data._id
      if (data.config_auto) {
        this.config_auto = this.clone(Object.assign(this.config_auto, data.config_auto))
      } else {

      }

      this.config_auto_date = {
        daily_start_day: null,
        daily_start_hour: null,
        daily_end_day: null,
        daily_end_hour: null,
        limit_usage: null,
        session_number: null,
        limit_session: null,
        allow_repeat: true,

        monthly_start_day: null,
        monthly_start_hour: null,
        monthly_end_day: null,
        monthly_end_hour: null,

        weekly_start_hour: null,
        weekly_end_hour: null,

        range_start_time: null,
        range_start_hour: null,
        range_end_time: null,
        range_end_hour: null
      }

      this.show_dialog.config_auto = true
    },

    async m__get_voucher_file() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_file/get', {shop_id: this.shop._id}, this.cf())
      this.voucher_file_list = response.body.data
    },

    async m__delete_voucher_file(data) {
      try {
        await this.$confirm(this.$t('base.delete_file_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
      }

      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_file/delete', {file_id: data._id}, this.cf())
      await this.m__get_voucher_file()
      this.ntf_s(this.$t('base.delete_success'))
    },

    async m__create_voucher_file() {
      if (!this.voucher_file_name) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      this.loading.create_voucher_file = true

      const response = await this.seller.marketing_get_voucher_detail(this.selected_voucher_id)

      const form = {
        name: this.voucher_file_name,
        type: this.selected_voucher_type,
        data: response.data.data,
        shop_id: this.shop._id
      }
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/voucher_file/create', form, this.cf())
      await this.m__get_voucher_file()
      this.loading.create_voucher_file = false
      this.show_dialog.create_voucher_file = false
      this.$t('base.save_success')
    },

    m__show_create_voucher_file_dialog(voucher_id, voucher_type) {
      this.selected_voucher_id = voucher_id
      this.selected_voucher_type = voucher_type
      this.show_dialog.create_voucher_file = true
    },

    m__show_create_component(copy_from_id, is_update = false) {
      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }

      this.copy_from_id = copy_from_id
      this.is_update = is_update

      this.create_component_state = 'create'
      this.current_component = 'create'
    },

    m__show_create_multiple_component() {
      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }

      this.current_component = 'create_multiple'
    },

    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
      if (!this.check_role(items[0], 'marketing', 'flash_sale')) {
        this.shopee_shop.selected = ''
        return
      }

      this.loading.get_flash_sale = true
      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            this.selected_shop = items[0]
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              this.flash_sale_list = []
              return
            }

            await Promise.all([
              this.m__get_voucher(),
              this.m__get_product(),
              this.m__get_voucher_metrics(),
            ])

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
        this.loading.get_flash_sale = false
      }
    },

    async m__get_voucher() {
      if (this.promotion_type === 'file') return

      this.loading.get_voucher = true
      const offset = this.voucher_filter.current_page * this.voucher_filter.page_size
      const limit = this.voucher_filter.page_size

      let voucher_name = '', voucher_code = ''
      if (this.search_voucher_type === 'name') voucher_name = this.search_keywords
      if (this.search_voucher_type === 'code') voucher_code = this.search_keywords

      const response = await this.seller.marketing_get_voucher(offset, limit, this.promotion_type, voucher_name, voucher_code)

      this.voucher_filter.total_count = response.data.data.total_count

      for (const item of response.data.data.voucher_list) {
        if (item.voucher_code.startsWith('VIDEO')) {
          item.type = 'Voucher Shopee Video'
        } else if (item.voucher_code.startsWith('LIVE')) {
          item.type = 'Voucher Shopee Live'
        } else {
          if (item.rule.hide) {
            if (item.voucher_code.startsWith('SFP-')) {
              item.type = this.$t('voucher.follow_prize_voucher')
            } else {
              item.type = this.$t('voucher.private_voucher')
            }
          } else if (item.rule.choose_users && item.rule.choose_users.shop_order_count === 1) {
            item.type = this.$t('voucher.new_buyer_voucher')
          } else if (item.rule.choose_users && item.rule.choose_users.shop_order_count > 1) {
            item.type = this.$t('voucher.repeat_buyer_voucher')
          } else {
            if (item.rule.shopids) {
              item.type = this.$t('voucher.shop_voucher')
            } else {
              item.type = this.$t('voucher.product_voucher')
            }
          }
        }
      }

      this.voucher_list = response.data.data.voucher_list
      this.loading.get_voucher = false
    },

    async m__stop_voucher(data) {
      try {
        await this.$confirm(this.$t('voucher.stop_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        if (data.voucher_code.startsWith('SFP-')) {
          await this.seller.marketing_follow_prize_operation({
            voucher_id: data.voucher_id,
            action: 'stop'
          })
        } else {
          await this.seller.marketing_stop_voucher(data.voucher_id)
        }
        await this.m__get_voucher()
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
      }
    },

    async m__delete_voucher(data) {
      try {
        await this.$confirm(this.$t('voucher.delete_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        if (data.voucher_code.startsWith('SFP-')) {
          await this.seller.marketing_follow_prize_operation({
            voucher_id: data.voucher_id,
            action: 'delete'
          })
        } else {
          await this.seller.marketing_delete_voucher(data.voucher_id)
        }
        await this.m__get_voucher()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      }
    },

    async m__get_product() {
      this.loading.get_product = true
      this.product_list = []

      let offset = 0, limit = 50
      let product_response = await this.seller.flash_sale_get_product(offset, limit)
      while (product_response.data.item_list && product_response.data.item_list.length) {
        for (const item of product_response.data.item_list) {
          item.add_to_cart_units = 0
          item.revenue = Math.floor(item.price * item.sold)
        }

        this.product_list.push(...product_response.data.item_list)

        offset += limit
        product_response = await this.seller.flash_sale_get_product(offset, limit)
      }

      // this.m__get_product_performance(this.seller).catch(console.error)

      this.loading.get_product = false
    },

    async m__get_product_performance(seller) {
      try {
        let page = 1, page_size = 20
        const start_time = this.dayjs().subtract(30, 'days').startOf('d').unix()
        const end_time = this.dayjs().startOf('d').unix()
        let product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')

        const performance_list = []
        while (!this.is_destroyed && this.seller && seller && this.seller.username === seller.username &&
        product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
        product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
          this.loading.get_product = true

          performance_list.push(...product_performance_resp.data.result.items)
          if (performance_list.length > product_performance_resp.data.result.total) {
            break
          }

          for (const product of product_performance_resp.data.result.items) {
            const product_found = this.product_list.find(i => i.itemid === product.id)
            if (product_found) product_found.add_to_cart_units = product.add_to_cart_units
          }

          await this.sleep(1000)
          page++
          product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')
        }
      } catch (e) {
      } finally {
        this.loading.get_product = false
      }
    }
  }
}
</script>

<style lang="scss">
.shopee-tag__information.success {
  color: #5c7;
  background-color: #eaf9ef;
}

.shopee-tag__information.default {
  color: #ee4d2d;
  background-color: #fff1f0;
}

.shopee-tag__information.invalid {
  color: #666;
  background-color: #eee;
}

.shopee-tag__information {
  line-height: 18px;
  border-style: none;
  border-radius: 2px;
}

.shopee-tag {
  position: relative;
  display: inline-block;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 500;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid transparent;
  border-right: 0;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.merge-select-input {
  .el-select > .el-input > input {
    border-right: unset !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .el-select > .el-input > input:focus {
    border-color: #c0c4cc !important;
  }

  .input > input {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/voucher/index.vue